module.exports = __webpack_public_path__ + "img/atm360-sm.0772da69.svg";